(() => {
  let active = null;

  const setupOverlay = () => {
    const drawer = document.getElementById("cart-drawer");
    if (!drawer) return;

    const overlayContainer = drawer.querySelector(".overlay-bottom");
    const overlayTrigger = drawer.querySelector(
      ".cart-footer-main [data-overlay-trigger]",
    );
    const scrollContainer = drawer.querySelector(".v-stack.rec-and-list-item");

    if (!overlayContainer || !overlayTrigger || !scrollContainer) return;

    let overlayTopRef = null;
    let overlayHidden = false;

    const measure = () => {
      overlayContainer.classList.remove("hidden");
      overlayTopRef = overlayContainer.getBoundingClientRect().top;
    };

    const update = () => {
      if (!scrollContainer.isConnected) return cleanup();

      const overflows =
        scrollContainer.scrollHeight > scrollContainer.clientHeight;

      if (!overflows) {
        overlayContainer.classList.add("hidden");
        overlayHidden = true;
        return;
      }

      const realTop = overlayTrigger.getBoundingClientRect().top;

      if (!overlayHidden && realTop <= overlayTopRef + 1) {
        overlayContainer.classList.add("hidden");
        overlayHidden = true;
      }

      if (overlayHidden && realTop > overlayTopRef + 4) {
        overlayContainer.classList.remove("hidden");
        overlayHidden = false;
      }
    };

    const cleanup = () => {
      scrollContainer.removeEventListener("scroll", update);
      window.removeEventListener("resize", measure);
      active = null;
    };

    // Initial layout AFTER DOM paint
    requestAnimationFrame(() => {
      measure();
      update();
    });

    scrollContainer.addEventListener("scroll", update);
    window.addEventListener("resize", measure);

    active = cleanup;
  };

  const observer = new MutationObserver(() => {
    // If old instance died → cleanup
    if (active) active();

    // Try attaching to new DOM
    setupOverlay();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
